export enum RewardItemTypeEnum {
    Apvar,
    Capvar,
    Kpi,
    PVC,
}

export const RewardItemTypeList = [
    { id: 0, name: 'APVAR' },
    { id: 1, name: 'CAPVAR' },
    { id: 2, name: 'KPI Benchmarking' },
    { id: 3, name: 'Practice Valuation Comparison' },
];
